import {useDispatch, useSelector} from 'react-redux';
import {IStore} from 'redux/interface';
import {loadMediaAction} from 'redux/media/mediaAsyncActions';
import {IMediaInitialState} from 'redux/media/interfaces';
import {deleteMediaApi, getMediaUrlApi} from '../../redux/api/media';
import {ImageSize} from '@wholesalechange/chatcomponent';

interface IUseLoadFile {
  media: IMediaInitialState
  getFileUrl: (fileId: number, callback?: (url: string | null) => void) => string
  getFileUrlAsync: (fileId: number, imageSize?: ImageSize) => Promise<string>
  removeFileAsync: (fileId: number) => Promise<boolean>
}

export function useLoadFile(): IUseLoadFile {
  const {
    media,
    status: {loading}
  } = useSelector((store: IStore) => store);
  const dispatch = useDispatch();

  function getFileUrl(fileId: number, callback?: (url: string | null) => void): string {
    if (media[fileId]) {
      if (callback) {
        callback(media[fileId]);
      }

      return media[fileId];
    }
    if (!loading.includes(fileId.toString())) {
      dispatch(loadMediaAction(fileId, callback));
    }

    return '';
  }

  async function getFileUrlAsync(fileId: number, imageSize?: ImageSize): Promise<string> {
    if (media[fileId]) {
      return media[fileId];
    }

    try {
      const {data: {value: fileUrl} } = await getMediaUrlApi(fileId, imageSize && imageSize === ImageSize.Original);

      return fileUrl;
    } catch (e) {
      console.log('getFileUrlAsync', e);
    }

    return '';
  }

  async function removeFileAsync(fileId: number): Promise<boolean> {
    const {data: {value: result} } = await deleteMediaApi(fileId);

    return result;
  }

  return {
    getFileUrl,
    getFileUrlAsync,
    removeFileAsync,
    media
  };
}
